import { GzIconWebComponent } from 'apps/webcomponents/src/index.ui';
import { entityIconSet } from 'apps/webcomponents/src/theme/entity-icons';
import { ButtonColor } from 'apps/webcomponents/src/ui/gzIconButton/types';
import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';

/**
 * @summary This component can be used to display SVG icons with icon set for Breach path graph
 * @tag gz-breach-path-graph-icon
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-breach-path-graph-icon')
export class BreachPathGraphIconWebComponent extends LitElement {
  /**
   * @type {string} name - this value needs to match the symbol id of the icon, i.e. 'ds-icon-clear', 'ds-icon-cancel' etc.
   * The component provides a preset SVG icon set. For custom icons, a valid SVG icon can be placed inside the <gz-icon> tags.
   * The full list of preset icons can be found here:
   * https://rcd-static.npunix.bitdefender.biz/storybooks/nirvana/latest/?path=/story/design-system--icons
   */
  @property({ type: String, attribute: true, reflect: true })
  name = '';

  /**
   * @type {string} color - the property accepts values from the ButtonColor enum or a custom HEX code or CSS color variable
   * Alternately, the icon color can be overridden in CSS by setting a custom fill color on the 'svgIcon' part, i.e.:
   * gz-icon::part(svgIcon) {
   *   fill: var(--red-alert-chart-700-critical);
   * }
   */
  @property({ type: String, attribute: true, reflect: true })
  color = '';

  /**
   * @type {number} size
   */
  @property({ type: Number, attribute: true, reflect: true })
  size = 20;

  iconInstance: GzIconWebComponent | null = null;

  constructor() {
    super();
    const gzIconElement = new GzIconWebComponent();
    gzIconElement.setCustomIconSet(entityIconSet);

    this.iconInstance = gzIconElement;
  }

  render() {
    if (this.iconInstance) {
      this.iconInstance.name = this.name;
      this.iconInstance.color = this.color as ButtonColor;
      this.iconInstance.size = this.size;
    }
    return html`${this.iconInstance}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-breach-path-graph-icon': BreachPathGraphIconWebComponent;
  }
}
